var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _setup.isMobile
    ? _c(_setup.CartButtonMobile, {
        attrs: {
          "is-trashbin-button":
            _setup.cartContentStore.cartButtonType ===
            _setup.CartButtonEnum.trashbin,
          "is-in-cart": _vm.isInCart,
          "cart-content-link": `/${_setup.commonAnalysesStore.town.translit}/analyses/cart/content/`,
          "disable-cart-button": _vm.disableCartButton,
        },
        on: {
          "click:add": _setup.handleAddAnalysisToCart,
          "click:delete": _setup.handleDeleteAnalysisFromCart,
        },
      })
    : _c(_setup.CartButtonDesktop, {
        attrs: {
          "is-trashbin-button":
            _setup.cartContentStore.cartButtonType ===
            _setup.CartButtonEnum.trashbin,
          "is-in-cart": _vm.isInCart,
          "cart-content-link": `/${_setup.commonAnalysesStore.town.translit}/analyses/cart/content/`,
          "disable-cart-button": _vm.disableCartButton,
        },
        on: {
          "click:add": _setup.handleAddAnalysisToCart,
          "click:delete": _setup.handleDeleteAnalysisFromCart,
        },
      })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }